import COLORS from './colors';
import LAYOUT from './layout';
import ZINDEX from './zindex';
import 'semantic-ui-css/semantic.min.css';
import 'react-table/react-table.css';
import { ReactTableDefaults } from 'react-table';

Object.assign(ReactTableDefaults, {
  showPagination: false,
  defaultPageSize: 25,
  sortable: false,
  column: {
    ...ReactTableDefaults.column,
    minWidth: 170,
  },
});
const THEME = {
  LAYOUT,
  ZINDEX,
  COLORS,
  FONT: {
    FAMILY: "'Open Sans', sans-serif !important;",
    SIZES: {
      xsmall: 8,
      smaller: 10,
      small: 12,
      normal: 14,
      medium: 16,
      large: 18,
      larger: 20,
      xlarge: 22,
    },
    WEIGHTS: {
      bolder: 800,
      bold: 700,
      semibold: 600,
      normal: 400,
      light: 300,
      lighter: 200,
      thin: 100,
    },
  },
  TEXT: {
    PADDING: 4,
    COLORS: {
      normal: COLORS.BLACK,
      light: '#7B7B7B',
      lighter: '#BAC0C3',
      primary: '#0177FF',
      positive: COLORS.POSITIVE,
      negative: COLORS.NEGATIVE,
      white: COLORS.WHITE,
    },
  },
  BUTTON: {
    HEIGHTS: {
      normal: 40,
      compact: 32,
    },
    SPINNERS: {
      normal: 16,
      compact: 10,
    },
    PADDING: 16,
    RADIUS: 4,
  },
  BUTTONS: {
    primary: {
      border: 0,
      background: 'linear-gradient(56.99deg, #0177FF 0%, #1F48D7 100%)',
      backgroundHover: 'linear-gradient(58.2deg, #0177FF 0%, #000000 100%)',
      backgroundDisabled: 'rgba(204, 220, 238, 0.5)',
      color: COLORS.WHITE,
      colorDisabled: '#CCDCEE',
    },
    inverted: {
      border: '1px solid #0177FF',
      borderHover: '1px solid #1657E4',
      borderDisabled: '1px solid #E6EEF7',
      background: 'transparent',
      color: '#0177FF',
      colorHover: '#1657E4',
      colorDisabled: '#CCDCEE',
    },
    gray: {
      border: 0,
      background: COLORS.GRAY,
      backgroundDisabled: 'rgba(204, 220, 238, 0.5)',
      color: COLORS.WHITE,
    },
    grayInverted: {
      border: '1px solid gray',
      background: 'transparent',
      color: COLORS.GRAY,
    },
    link: {
      border: 0,
      background: 'transparent',
      color: '#0177FF',
      colorHover: '#1657E4',
      colorDisabled: '#CCDCEE',
    },
  },
  CARD: {
    background: COLORS.WHITE,
    radius: 4,
    shadow: '4px 6px 8px 0 rgba(0,0,0,0.4)',
  },
};

export default THEME;
